
export const FETCH_PRODUCTION_REPORTS_DATA_REQUEST = 'FETCH_PRODUCTION_REPORTS_DATA_REQUEST';
export const FETCH_PRODUCTION_REPORTS_DATA_SUCCESS = 'FETCH_PRODUCTION_REPORTS_DATA_SUCCESS';
export const FETCH_PRODUCTION_REPORTS_DATA_FAILURE = 'FETCH_PRODUCTION_REPORTS_DATA_FAILURE';

export const SET_SUMMARY_GRID_NAME_PRODUCTION_REPORT = 'SET_SUMMARY_GRID_NAME_PRODUCTION_REPORT';

export const CREATE_USER_FORM_PRODUCTION_REPORT = 'CREATE_USER_FORM_PRODUCTION_REPORT';


export const FETCH_PROGRAM_REPORTS_DATA_REQUEST = 'FETCH_PROGRAM_REPORTS_DATA_REQUEST';
export const FETCH_PROGRAM_REPORTS_DATA_SUCCESS = 'FETCH_PROGRAM_REPORTS_DATA_SUCCESS';
export const FETCH_PROGRAM_REPORTS_DATA_FAILURE = 'FETCH_PROGRAM_REPORTS_DATA_FAILURE';